// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"99d29a1b","94":"a1b9bf2c","619":"a71b5bf3"}[chunkId] + ".chunk.js";
};